// ScheduleListItem Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import Util from '../../../lib/util.jsx'
import DateUtil from '../../../lib/dateutil.jsx'
import IconButton from '../../../common/common/icon_button/icon_button.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'

class ScheduleListItem extends Component {
  constructor (props) {
    super(props)

    this.state = {
      bShowItems: props.expand
    }
  }

  static get propTypes () {
    return {
      expand: PropTypes.bool,
      schedule: PropTypes.object,
      onSetting: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      expand: false,
      schedule: null,
      onSetting: null
    }
  }

  render () {
    const schedule = this.props.schedule
    const date = new Date(schedule.fromDate)

    let noItems = 0
    let totalHours = 0
    if (schedule.schedules && schedule.schedules.length > 0) {
      noItems = schedule.schedules.length
      schedule.schedules.forEach((item) => {
        totalHours += item.timeTaken || 0
      })

      totalHours = parseFloat(totalHours / 2 / 60)
    }

    const _className = classnames('schedulelist-item', {
      expanded: this.state.bShowItems
    })

    return (
      <div className={_className}>
        <div className='coldate'>
          <div className='month'>{DateUtil.getDisplayMonth(date)}</div>
          <div className='day'>{DateUtil.getDisplayDay(date)}</div>
          <div className='year'>{DateUtil.getDisplayYear(date)}</div>
        </div>
        <div className='colsplit' />
        <div className='colinner'>
          <h4 className='title'>
            {totalHours} <IntlMessage ident='user.schedule.titleTotalHours' />
          </h4>
          <div className='info'>
            {noItems > 0 && (
              <div
                className='item-cont'
                onClick={this._onClickExpand.bind(this)}
              >
                <span className='item'>
                  <IntlMessage
                    ident={`user.schedule.${
                      schedule.toDate ? 'itemExpiresOn' : 'noEndDate'
                    }`}
                  />
                  {schedule.toDate
                    ? ' ' + DateUtil.getDisplayDate(schedule.toDate)
                    : ''}
                </span>
                <span className='iconcont'>
                  <i className='icon icon-grid-expand normal' />
                  <i className='icon icon-grid-expand-hover hover' />
                </span>
              </div>
            )}
          </div>
        </div>
        {this.state.bShowItems && noItems > 0 && (
          <div className='scheduleitems'>
            <div className='itemhead'>
              <div className='itemcol'>
                <IntlMessage ident='user.schedule.weeks' />
              </div>
              <div className='itemcol'>
                <IntlMessage ident='user.schedule.dayMonday' />
              </div>
              <div className='itemcol'>
                <IntlMessage ident='user.schedule.dayTuesday' />
              </div>
              <div className='itemcol'>
                <IntlMessage ident='user.schedule.dayWednesday' />
              </div>
              <div className='itemcol'>
                <IntlMessage ident='user.schedule.dayThursday' />
              </div>
              <div className='itemcol'>
                <IntlMessage ident='user.schedule.dayFriday' />
              </div>
              <div className='itemcol'>
                <IntlMessage ident='user.schedule.daySaturday' />
              </div>
              <div className='itemcol'>
                <IntlMessage ident='user.schedule.daySunday' />
              </div>
            </div>
            <div className='itemrow'>
              <div className='itemcol'>1</div>
              {this._renderScheduleItems(schedule.schedules.slice(0, 7))}
            </div>
            <div className='itemrow'>
              <div className='itemcol'>2</div>
              {this._renderScheduleItems(schedule.schedules.slice(7))}
            </div>
          </div>
        )}
        <IconButton
          title=''
          icon='common-action-setting'
          size='small'
          onClick={this._onSetting.bind(this)}
        />
      </div>
    )
  }

  /* Event handlers */
  _renderScheduleItems (items) {
    return items.map((item) => {
      return (
        <div className='itemcol' key={item.dayNo}>
          {this._formatTimeForInput(item.timeTaken)}
        </div>
      )
    })
  }

  _formatTimeForInput (timeTaken) {
    if (timeTaken === 0) {
      return '0:00'
    }

    return timeTaken ? Util.convertMinutesToHour(timeTaken) : ''
  }

  _onSetting (e) {
    e.preventDefault()
    e.stopPropagation()

    if (this.props.onSetting) {
      this.props.onSetting()
    }
  }

  _onClickExpand (e) {
    e.preventDefault()
    e.stopPropagation()

    this.setState({ bShowItems: !this.state.bShowItems })
  }
}

export default ScheduleListItem
